import { ComponentsOverrides, Theme } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

declare module '@mui/material/Button' {

  interface ButtonPropsColorOverrides {
    transparent: true,
  }
}

export const ButtonStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiButton'] =>
  (
    {
      root: { // variant: text
        textTransform: 'none',
        whiteSpace: 'nowrap',
        fontWeight: 600,
        height: 'fit-content',
        minWidth: '5rem',
        padding: '0.5rem 0.75rem',
        borderRadius: 6,

        '&.Mui-disabled': {
          color: muiPalette.text.disabled,
        },

        '&.MuiButton-text': {
          '&.MuiButton-colorInherit': {
            color: palette?.text?.primary,
          },
        },
      },

      contained: {
        '&:hover': {
          backgroundColor: muiPalette.primary.dark,
        },

        '&.Mui-disabled': {
          color: muiPalette.text.disabled,
          backgroundColor: muiPalette.action.disabledBackground,
        },
      },

      outlined: {
        color: muiPalette.primary.main,
        borderColor: muiPalette.primary.main,

        '&:hover': {
          color: muiPalette.primary.dark,
          borderColor:  muiPalette.primary.dark,
        },

        '&.Mui-disabled': {
          color: muiPalette.text.disabled,
        },
      },

      text: {
        '&:hover': {
          backgroundColor: 'inherit',
        },

        '&.Mui-disabled': {
          color: muiPalette.text.disabled,
        },
      }
    }
  );